import * as React from "react";
import TabbedPaperLayout, { TabbedPaperLayoutProps } from "./TabbedPaperLayout";
import RunbooksNavigationTabs from "../RunbooksNavigationTabs";
import StringHelper from "utils/StringHelper";

type RunbooksPaperLayoutProps = TabbedPaperLayoutProps;
const RunbooksPaperLayout: React.FC<RunbooksPaperLayoutProps> = ({ tabNavigation = RunbooksNavigationTabs, breadcrumbTitle = "Runbooks", title = StringHelper.ellipsis, disableAnimations = true, fullWidth = true, ...rest }) => (
    <TabbedPaperLayout breadcrumbTitle={breadcrumbTitle} title={title} tabNavigation={tabNavigation} disableAnimations={disableAnimations} fullWidth={fullWidth} {...rest} />
);

export default RunbooksPaperLayout;
export { RunbooksPaperLayout };
